import { create } from "zustand";

interface MainnetToTestnetSwitchStoreType {
  isMainnet: boolean;
  isSwitching: boolean;
  setIsSwitching: (status: boolean) => void;
  setSwitchStatus: (status: boolean) => void;
}

/**
 * A Zustand store for managing the state of a mainnet-to-testnet switcher on the bridge-scanner.
 *
 * This store provides the following state and actions:
 * - `isMainnet`: A boolean indicating whether the current network is mainnet.
 * - `isSwitching`: A boolean indicating whether a network switch is in progress.
 * - `setIsSwitching(status: boolean)`: A function to update the `isSwitching` state.
 * - `setSwitchStatus(status: boolean)`: A function to update the `isMainnet` state.
 *

 */
export const useMainnetToTestnetSwitchStore =
  create<MainnetToTestnetSwitchStoreType>((set) => ({
    isMainnet: true,
    isSwitching: false,
    setIsSwitching: (status) => set({ isSwitching: status }),
    setSwitchStatus: (status) => set({ isMainnet: status }),
  }));
